import { Component, OnInit } from '@angular/core';
import { CommonService } from '../_services';
import { Router } from '@angular/router';
import {ActivatedRoute} from '@angular/router';
import {environment} from '../../environments/environment';
import { Chart } from 'angular-highcharts';
import * as Highcharts from 'highcharts/highstock';
import * as moment from 'moment';

@Component({
  selector: 'app-industry-public-view',
  templateUrl: './industry-public-view.component.html',
  styleUrls: ['./industry-public-view.component.css']
})

export class IndustryPublicViewComponent implements OnInit {

  industryId;
  industryProfileDetail = [];
  lineChart: Chart;
  getIndustryDetailLoader = false;
  route = '';
  deviceResponseChart = [];
  stationIds = [];
  getStationDeviceDetailsLoader = false;
  getStationDeviceLatestResultLoader = [];
  stationDeviceDetail = [];
  stationDeviceLatestResult = [];


  constructor(private activeroute: ActivatedRoute,private router: Router,
              private _service: CommonService) { }

  ngOnInit() {
    this.activeroute.queryParams.subscribe(params => {
      this.industryId = params['industry_id'];
    });
    this.getIndustryDetail();
    this.getStationDeviceDetails();
    // this.getStationDeviceLatestResult();
  }



  getIndustryDetail(){
    this.getIndustryDetailLoader = true;
    this.route  = 'get-industry-profile-details-public';
    // const token    = localStorage.getItem('userToken');
    this.industryProfileDetail = [];
    let data = {'industry_id':this.industryId};

    this._service.postRequestNoTokenCreator(data, this.route).subscribe((response: any) => {
      if(response.status == 200){
        this.industryProfileDetail = response.data;
      }
      this.getIndustryDetailLoader = false;
    });
  }

  printPage(){
      const printContent = document.getElementById("industry-profile-public-view");
      const WindowPrt = window.open('', '', 'left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0');
      WindowPrt.document.write(printContent.innerHTML);
      WindowPrt.document.close();
      WindowPrt.focus();
      WindowPrt.print();
      WindowPrt.close();
  }

  getStationDeviceDetails(){
    this.getStationDeviceDetailsLoader = true;

    this.route  = 'get-industry-station-device-details-public';
    this.stationDeviceDetail = [];
    let data = {'industry_id':this.industryId};
    // const token    = localStorage.getItem('userToken');

    this._service.postRequestNoTokenCreator(data, this.route).subscribe((response: any) => {

      if(response.status == 200){
        this.stationDeviceDetail = response.data;
        this.stationIds = response.stations;
        this.getStationDeviceDetailsLoader = false;


        for (var stationId in response.stations) {
          this.getStationDeviceLatestResult(response.stations[stationId]);
        }
      }
    });

  }

  getStationDeviceLatestResult(stationId){

    this.getStationDeviceLatestResultLoader['stat_'+stationId] = true;
    this.route  = 'get-station-device-latest-result-public';

    let data = {'industry_id':this.industryId,'station_id':stationId};

    this._service.postRequestNoTokenCreator(data, this.route).subscribe((response: any) => {

      if(response.status == 200){
        this.stationDeviceLatestResult = response.data;

        if(this.stationDeviceLatestResult){
          for (var stationKey in this.stationDeviceLatestResult) {

            let deviceResponseRow = [];
            let parameterName = '';
            let lastDate = '';

            this.deviceResponseChart[stationKey] = [];

            for (var parameterKey in this.stationDeviceLatestResult[stationKey]) {

              this.deviceResponseChart[stationKey] = this.lineChart ;

              parameterName = this.stationDeviceLatestResult[stationKey][parameterKey]['parameter'];
              deviceResponseRow.push([parameterKey,parseFloat(this.stationDeviceLatestResult[stationKey][parameterKey]['value'])]);
            }
            lastDate = this.stationDeviceLatestResult[stationKey][parameterKey]['date_time'];
              this.getStationDeviceLatestResultLoader['stat_'+stationId] = false;
            this.drawLineChart(stationKey,parameterKey,parameterName,deviceResponseRow,lastDate);
          }

        }else{
            this.deviceResponseChart['stat_'+stationId] = false;
            this.getStationDeviceLatestResultLoader['stat_'+stationId] = false;
        }

      }

    });
  }

  drawLineChart(station,parameterKey,parameterName,chartvalue,lastDate) {

      let lineChartLocal = new Chart({
        chart: {
          type: 'column'
        },
        title: {
          text: ''
        },
        subtitle: {
          text: ''
        },
        yAxis: {
          title: {
            // visible: true,
            text: ''
          }
        },
        xAxis: {
          // visible: true,
          type: 'category',
          labels: {
            rotation:-45,
            formatter: function(){
              return ((this.value as string).toUpperCase());
            },
          },
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true,
              align: 'center',
              color: '#000'
            },
          }
        },
        legend: {
          enabled: false
        },
        tooltip: {
          backgroundColor: '#EEF3F6',
          borderColor: 'black',
          borderRadius: 10,
          borderWidth: 1,
          formatter: function(){
            return '<b>'+ this.key.toUpperCase() +':</b> ' + this.y + '<br/><b>Time:</b> '+  moment(new Date(lastDate)).format('DD MMM YYYY HH:mm');
          }
        },
        credits: {
          enabled: false
        },
        series: [{
          name: 'Population',
          data: chartvalue,
          type: 'line',
        }]
      });

    this.deviceResponseChart[station] = lineChartLocal;
    console.log(this.deviceResponseChart);
  }


}
